const system = {
  menuManager: {
    menu: "เมนู",
    button: "ปุ่ม",
    menuName: "ชื่อเมนู (CN)",
    menuNameEn: "ชื่อเมนู (EN)",
    link: "ลิงค์",
    menuType: "ประเภทเมนู",
    sort: "จัดเรียง",
    isShow: "แสดงหรือไม่",
    weight: "Menu weight",
    otherWeight: "Extend menu weight",
    create: "เพิ่ม",
    update: "อัปเดต",
    delete: "ลบ",
    topLevelMenu: "เมนูระดับบนสุด",
    parentMenu: "เมนูหลัก",
    icon: "ไอคอน",
    hide: "ซ่อน",
    show: "แสดง",
    permission: "Permission ID",
    msg: {
      error1: "โปรดป้อนชื่อเมนูภาษาจีน",
      error2: "โปรดป้อนหมายเลขการจัดเรียง",
      error3: "กรุณากรอกชื่อเมนูภาษาอังกฤษ",
      error4: "Please select menu weight"
    },
    weightList: {
      list1: "นักพัฒนา",
      list2: "V2x",
      list3: "แชนแนล",
      list4: "บริษัท",
      list5: "บริษัทย่อย",
      list6: "สาขา"
    },
    rightLabelWidth: "135px",
    leftLabelWidth: "135px"
  },
  repair: {
    searchTitle: "Item name",
    searchTitle1: "Item group",
    searchName: {
      first: "Basic Repair",
      second: "Deep Repair"
    },
    itemName: "Item name",
    itemNameEn: "English name of the item",
    itemType: "Item group",
    readOnly: "Created by yourself",
    createdOn: "Creation time",
    tableWidth: {
      itemName: "100",
      itemNameEn: "100",
      itemType: "100",
      createdOn: "110",
      readOnly: "100"
    },
    create: "New Repair",
    update: "Editor Repair",
    msg: {
      error1: "Please enter the item name",
      error2: "Please enter the English name of the item",
      error3: "Please select item group",
      readOnly: "No",
      editable: "Yes",
      readOnlyTip: "You don't have permission to operate this item"
    }
  },
  maintenance: {
    searchTitle: "Item name",
    searchTitle1: "Item group",
    searchName: {
      first: "Basic Maintenance",
      second: "Deep Maintenance",
      third: "Cleaning And Maintenance",
      custom: "Custom"
    },
    itemName: "Item name",
    itemNameEn: "English name of the item",
    itemType: "Item group",
    readOnly: "Created by yourself",
    createdOn: "Creation time",
    tableWidth: {
      itemName: "100",
      itemNameEn: "100",
      itemType: "100",
      createdOn: "110",
      readOnly: "100"
    },
    create: "New maintenance",
    update: "Edit maintenance",
    msg: {
      error1: "Please enter the item name",
      error2: "Please enter the English name of the item",
      error3: "Please select item group",
      readOnly: "No",
      editable: "Yes",
      readOnlyTip: "You don't have permission to operate this item"
    }
  },
  user: {
    searchName: "ชื่อบัญชี",
    loginAccount: "ชื่อล็อคอิน",
    userName: "ชื่อ",
    role: "บทบาท",
    lockStatus: "Lock status",
    userRole: "กลุ่มผู้ใช้งาน",
    accountType: "Account type",
    accountStatus: "สถานะบัญชี",
    enable: "ใช้งานได้",
    ban: "ใช้งานไม่ได้",
    restPwdTips: "Please select the user needs to reset the password",
    openingTime: "วันที่สร้าง",
    searchLabelWidth1: "100px",
    yes: "Yes",
    no: "No",
    labelWidth: "110px",
    msg1: "หลังจากรีเซ็ต， รหัสผ่านคือ 12345678",
    msg2: "รีเซ็ตรหัสผ่านสำเร็จแล้ว",
    tips: "โปรดเลือกรายการที่ต้องการรีเซ็ต",
    passwordTips: "Please check the item requiring password reset",
    tableWidth: {
      loginAccount: "130",
      userName: "120",
      accountStatus: "140",
      phoneNumber: "140",
      openingTime: "140"
    },
    createAndUpdate: {
      create: "เพิ่มผู้ใช้ใหม่",
      update: "แก้ไขผู้ใช้",
      msg: {
        error1: "กรุณาเข้าสู่ระบบบัญชี",
        error2: "กรุณากรอกชื่อผู้ใช้",
        error3: "โปรดเลือกบทบาท"
      }
    },
    banTips: "ปิดการใช้งานผู้ใช้"
  },
  defaultPwd: "Default password",
  logs: {
    login: {
      loginAccount: "ชื่อล็อกอิน",
      userName: "ชื่อผู้ใช้",
      clientIP: "IP ของไคลเอ็นต์",
      resultsLogin: "ผลการเข้าสู่ระบบ",
      accountType: "Account type",
      loginTime: "เวลาเข้าสู่ระบบ",
      clientBrowser: "เบราว์เซอร์ไคลเอนต์",
      searchWidth: {
        width1: "75px",
        width2: "60px",
        width3: "105px",
        width4: "80px"
      },
      success: "ประสบความสำเร็จ",
      fail: "ความล้มเหลว"
    },
    oper: {
      loginAccount: "ชื่อล็อกอิน",
      userName: "ชื่อผู้ใช้",
      clientIP: "IP ของไคลเอ็นต์",
      roleName: "ชื่อบทบาท",
      operatingFunctions: "ฟังก์ชัน Oper",
      operatingActions: "กิจกรรม",
      operationDescription: "คำอธิบาย Oper",
      operatingTime: "เวลา",
      browserInformation: "ข้อมูลเบราว์เซอร์",
      operatingResults: "ผลการดำเนินการ",
      searchWidth: {
        width1: "110px",
        width2: "80px",
        width3: "120px",
        width4: "90px"
      },
      tableWidth: {
        loginAccount: "130",
        userName: "140",
        roleName: "130",
        operatingFunctions: "180",
        operatingResults: "150",
        browserInformation: "180"
      }
    },
    lifecycle: {
      loginAccount: "Login name",
      userName: "User name",
      accountType: "Account type",
      logDescription: "Log description",
      logType: "Log type",
      operatingTime: "Operation time",
      operator: "Operator",
      operationDescription: "Operation description",
      searchWidth: {
        width1: "100px",
        width2: "80px",
        width3: "90px",
        width4: "100px"
      },
      tableWidth: {
        loginAccount: "130",
        userName: "110",
        operator: "100",
        accountType: "130",
        roleName: "100",
        logType: "150",
        operatingTime: "240"
      }
    }
  },
  role: {
    name: "การจัดการบทบาท",
    searchLabelWidth: "120px",
    remark: "Remark",
    isSys: "บทบาทของระบบ",
    dataScope: "การอนุญาตข้อมูล",
    datascope0: "ไม่ได้ตั้งค่า",
    datascope1: "ทั้งหมด",
    tips: "โปรดเลือกรายการที่จะตั้งค่า",
    tableWidth: {
      name: "130px",
      isSys: "100px",
      dataScope: "150px"
    },
    create: "บทบาทใหม่",
    update: "แก้ไขบทบาท",
    basicInfo: "ข้อมูลพื้นฐาน",
    menu: "รายการกำหนดสิทธิ์",
    error: "โปรดป้อนชื่อบทบาท"
  },
  channel: {
    create: "เพิ่มแชนแนลใหม่",
    update: "Edit Channel Manager",
    name: "ชื่อแชนแนล",
    channelLabelWidth: "102px",
    info: "ข้อมูลแชนแนล",
    define: "ยืนยัน",
    edit: "แก้ไขแชนแนล",
    tips: "โปรดเลือกแชนแนล",
    confirm: "ตกลง",
    delete: "ลบแชนแนล",
    deleteItemTips: "คุณแน่ใจที่จะลบแชนแนลที่เลือกหรือไม่",
    resetPassword: "รีเซ็ตรหัสผ่านแชนแนล",
    msg: "โปรดยืนยันเพื่อรีเซ็ทรหัสผ่าน รหัสผ่านเริ่มต้นคือ 12345678",
    obdTips: "กำหนดสิทธิ์อุปกรณ์",
    valid: {
      name: "Please enter the channel name"
    }
  },
  company: {
    name: "ชื่อบริษัท",
    searchLabelWidth: "65px",
    remark: "สังเกต",
    tableWidth: {
      name: "130px",
      isSys: "80px",
      dataScope: "150px"
    },
    create: "บริษัท ใหม่",
    update: "แก้ไข บริษัท",
    info: "ข้อมูล บริษัท",
    admin: "ข้อมูลผู้ดูแลระบบ",
    adminAccount: "ชื่อล็อคอิน",
    adminRealName: "ชื่อ",
    phoneNumber: "เบอร์มือถือ",
    dialogLabelWidth: "120px",
    valid: {
      name: "Please enter the company name",
      account: "Please enter the company administrator account",
      realName: "Please enter the company administrator name",
      mobile: "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง"
    },
    obdCount: "อุปกรณ์ที่ได้รับสิทธิ์",
    addObd: "เพิ่มการอนุญาต OBD",
    removeObd: "ลบการอนุญาต OBD"
  },
  subCompany: {
    name: "ชื่อบริษัทย่อย",
    subCompanyLabelWidth: "120px",
    create: "สร้าง บริษัท ย่อย",
    update: "แก้ไข บริษัท ย่อย",
    info: "ข้อมูล บริษัท ย่อย",
    valid: {
      name: "Please enter the sub company name"
    }
  },
  department: {
    name: "Department name",
    create: "New department manager",
    update: "Edit Department Manager",
    departmentLabelWidth: "110px",
    info: "Department information",
    valid: {
      name: "Please enter the department name"
    }
  },
  brand: {
    brand: {
      brandName: "Brand name",
      brandIcon: "Brand icon",
      brandCode: "Brand code",
      addBrand: "Add brand",
      editBrand: "Edit brand",
      selectIcon: "Select Brand Icon",
      carSeries: "Car series",
      errorIcon: "Please select a brand icon",
      errorName: "Please enter brand name",
      errorCode: "Please enter brand code",
    },
    series: {
      seriesName: "Series name",
      seriesCode: "Series code",
      addSeries: "Add series",
      editSeries: "Edit series",
      carModel: "Car model",
      goBackBrand: "Go back to car brand",
      errorName: "Please enter series name",
      errorCode: "Please enter series code",
    },
    model: {
      modelName: "Model name",
      modelCode: "Model code",
      addModel: "Add model",
      editModel: "Edit model",
      modelMaintenanceKm: "Model maintenance kilometer",
      modelMaintenanceTime: "Model maintenance time",
      modelDisplacement: "Model displacement",
      displacementUnit: "Displacement unit",
      modelCylinder: "Model cylinder",
      modelYear: "Model year",
      goBackSeries: "Go back to car series",
      errorName: "Please enter model name",
      errorCode: "Please enter model code",
    },
    brandLabelWidth: "80px",
    remark: "Remark",
  },
  pdpa:{
    labelWidth:'100px',
    appName:'App name',
    version: 'Version',
    createTime: 'Creation time',
    thailandurl: 'Thai url',
    englishurl: 'English url',
    fabu:'Release',
    yifabu:'The published',
    tableWidth:{
      appName:'100px',
      version: '100px',
      createTime: '140px',
      thailandurl: '250px',
      englishurl: '250px',
    },
    labelWidth2:'110px',
    v2x:'V2X-A2',
    playconnect:'PlayConnect',
    typeSelect:'Effective date',
    thailand: 'Thailand',
    english: 'English',
    appTypemsg:'Please select the App type',
    effectiveDatemsg:'Please select an effective time',
    playCtyzt:'PlayConnect_PDPA consent status',
    playCversion:'PlayConnect_PDPA version',
    playCtime:'PlayConnect_PDPA consent time',
    v2xtyzt:'V2X-A2_PDPA consent status',
    v2xversion:'V2X-A2_PDPA version',
    v2xtime:'V2X-A2_PDPA consent time',
    tipsfabu:"Are you sure to publish?",
    ty:'Agree',
    bty:"Don't agree with"
  }
} 
export default system